// extracted by mini-css-extract-plugin
export default {"mobile-row":"convenient_mobile-row__VOCak","mobile-col":"convenient_mobile-col__RoAb2","mobile-icon":"convenient_mobile-icon__oBIYG"};